import BoxIcon from '@components/icons/box'

type SubmitCustomizationModalProps = {
	isSubmitting: boolean
}

export default function SubmitCustomizationModal({ isSubmitting }: SubmitCustomizationModalProps) {
	return (
		<div
			className="bg-[#FDF1E3]/90 h-full fixed inset-0 overflow-y-auto flex items-center flex-col z-[4000]"
			role="dialog"
			aria-modal="true"
		>
			{isSubmitting ? (
				<div className="m-auto text-center">
					{/* Add to prismic */}
					<div className="max-w-full flex flex-col justify-center items-center">
						<div className="border-gray-300 h-32 w-32 animate-spin rounded-full border-[10px] border-t-[#FF5C39]" />
					</div>
					<p className="text-[16px] mt-4 w-32">Building your box...</p>
				</div>
			) : (
				<div className="m-auto text-center w-[390px]">
					{/* Add to prismic */}
					<h2 className="text-5xl title">Thank you!</h2>
					<p className="text-[26px] subtitle">
						We will let you know when your items are ready to ship
					</p>
					<div className="max-w-full flex flex-col justify-center items-center mt-16">
						<BoxIcon />
					</div>
				</div>
			)}
		</div>
	)
}
